import { TextAreaStyles, TextAreaTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system";
import { TextArea } from "./textarea";
/**
 * The Fabric Text Area component.
 *
 * @public
 */
export const definition = TextArea.compose({
    name: `${DesignSystem.prefix}-textarea`,
    template: TextAreaTemplate,
    styles: TextAreaStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=textarea.definition.js.map